// Orditas — public-page enhancements.
//
// Loaded through web_include_js, so it runs on login, portal and website pages.
//
// Its only job today is to give the login page's brand panel some content. That panel is
// drawn in CSS as `body[data-path="login"]::before`, and it stays exactly as it is if this
// script never runs: the markup below is layered into the same grid cell, so a JS failure
// degrades to the previous appearance rather than to a broken layout.
//
// We inject rather than override frappe's www/login.html. Our app's www/ would win over
// frappe's, but that would put us on the hook for every upstream change to the login page —
// the same reasoning recorded for the CSS in orditas_web.bundle.scss.
(function () {
	"use strict";

	// Strings are translated server-side and handed over in window.__orditas_login, because
	// frappe._messages is not populated for guest website pages — frappe._() there would
	// silently hand back the English source. English remains the fallback, so a login page
	// that loses the payload is still a usable login page.
	function t(text) {
		try {
			var strings = window.__orditas_login;
			return (strings && strings[text]) || text;
		} catch (e) {
			return text;
		}
	}

	function buildPanel() {
		var aside = document.createElement("aside");
		aside.className = "od-login-aside";
		// Decorative duplicate of what the form already says; keep it out of the a11y tree
		// so screen-reader users are not read the brand twice before reaching the fields.
		aside.setAttribute("aria-hidden", "true");

		var brand = document.createElement("div");
		brand.className = "od-login-brand";

		var mark = document.createElement("img");
		// The current mark comes from the brand index, through the page (api.py _login_strings, slice 7).
		mark.src =
			(window.__orditas_login && window.__orditas_login.__mark) ||
			"/assets/orditas_theme/images/orditas-mark-light.svg";
		mark.alt = "";
		mark.width = 60;
		mark.height = 60;

		var name = document.createElement("span");
		name.textContent = "Orditas";

		brand.appendChild(mark);
		brand.appendChild(name);

		var tagline = document.createElement("p");
		tagline.className = "od-login-tagline";
		tagline.textContent = t("Your business, in order.");

		var sub = document.createElement("p");
		sub.className = "od-login-sub";
		sub.textContent = t("Sales, inventory, accounting and compliance in one place.");

		var foot = document.createElement("p");
		foot.className = "od-login-foot";
		foot.textContent = t("Signing in to your Orditas workspace.");

		aside.appendChild(brand);
		aside.appendChild(tagline);
		aside.appendChild(sub);
		aside.appendChild(foot);
		return aside;
	}

	function init() {
		try {
			if (document.body.getAttribute("data-path") !== "login") return;
			// Frappe's login card shows the logo (our wordmark) with no text alternative.
			var logo = document.querySelector(".page-card-head .app-logo");
			if (logo && !logo.hasAttribute("alt")) logo.setAttribute("alt", "Orditas");
			if (document.querySelector(".od-login-aside")) return;
			// The switch "Branded login page" (Orditas Theme Settings): the server marks <html> while it is on.
			if (!document.documentElement.hasAttribute("data-od-login")) return;
			document.body.insertBefore(buildPanel(), document.body.firstChild);
		} catch (e) {
			// Never let decoration break authentication.
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
